// src/components/testpage/TestPageHeader.jsx
import React from 'react';
import { Typography, Chip, Alert, Box } from '@mui/material';

const TestPageHeader = ({ modelError }) => {
  return (
    <Box mb={3}> {/* Added mb for spacing after header */}
      <Typography 
        variant="h4" // Changed from h3 to h4 for better semantic hierarchy if page has an AppBar h1/h2
        component="h1" 
        fontWeight="bold" 
        gutterBottom 
        sx={{ display: 'flex', alignItems: 'center', mb: modelError ? 1 : 2 }} // Adjust margin based on modelError
      >
        Banty Chat Widget Test Page
        <Chip label="V2 Loader" color="primary" size="small" sx={{ ml: 1.5, fontWeight: 500}} />
      </Typography>
      {modelError && (
        <Alert severity="warning" sx={{mb:2}}>
          Error loading LLM models: {modelError.message || String(modelError)}
        </Alert>
      )}
    </Box>
  );
};

export default TestPageHeader;